import SectorHero from "@/components/SectorHero";
import TopicGrid from "@/components/TopicGrid";
import MethodTimeline from "@/components/MethodTimeline";
import RealisationsGallery from "@/components/RealisationsGallery";
import StatsBand from "@/components/StatsBand";
import ContactSection from "@/components/ContactSection";
import { commercialTopics } from "@/data/sectors";

export default function Tertiaire() {
  return (
    <div data-testid="tertiaire-page">
      <SectorHero
        kicker="02 · Tertiaire & Commerce"
        title="Décarbonez votre patrimoine sans alourdir votre P&L."
        blurb="Hôtels, hôpitaux, supermarchés, bureaux, entrepôts logistiques… ECONATION orchestre des programmes CEE multi-sites qui réduisent vos charges d'exploitation, améliorent le confort et alignent vos actifs sur les obligations du Décret Tertiaire."
        image="https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mjc5MDY0NHww&ixlib=rb-4.1.0&q=85"
        tags={["Décret Tertiaire", "Reporting ESG", "Multi-sites", "Asset-level ROI", "OPEREMA"]}
      />
      <TopicGrid
        kicker="Catégories adressées"
        title="De l'hôtellerie à la santé — un protocole CEE pour chaque typologie."
        topics={commercialTopics}
        dense
      />
      <MethodTimeline />
      <StatsBand dark={false} />
      <RealisationsGallery limit={3} />
      <ContactSection />
    </div>
  );
}
